import React, {useEffect, useState} from 'react';
import {Button} from '@material-ui/core';
import {
  reduxToggleSidePanel,
  reduxUpdateProductDepotInfo,
} from 'appredux/actions';
import CheckIcon from 'components/CheckIcon/CheckIcon';
import {Route} from 'react-router-dom';
import {
  IFarmInputProductDepotInfoInput,
  IDepot,
  IFarmInputProduct,
  IFarmInputProductDepotInfo,
  ISupplierUserProfile,
} from 'constants/interfaces';
import {apiGetProductDepotInfo, apiSaveProductDepotInfo} from 'constants/Api';
import {InventoryForm} from 'components/ProductForm/InventoryForm';
import {Skeleton} from '@material-ui/lab';
import {PermissionsService} from 'services/PermissionsService';
import {ESupplierUserPermissions} from 'constants/index';

const AddOrUpdateInventory = (props: {
  user: ISupplierUserProfile;
  allDepots: IDepot[];
  product: IFarmInputProduct;
  depotIds: string[];
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [hasSuccessfullyUpdated, setHasSuccessfullyUpdated] = useState(false);

  const [isLoadingDepotInfo, setIsLoadingDepotInfo] = useState(false);
  const [productDepotInfo, setProductDepotInfo] = useState<
    IFarmInputProductDepotInfo[]
  >([]);

  useEffect(() => {
    setIsLoadingDepotInfo(true);
    apiGetProductDepotInfo({
      productIds: [props.product.id.toString()],
      depotIds: props.depotIds,
    })
      .then(setProductDepotInfo)
      .catch((err) => {
        alert('Failed to load inventory. Please try again later');
        console.error(err);
        setProductDepotInfo([]);
      })
      .finally(() => setIsLoadingDepotInfo(false));
  }, [props.product?.id, props.depotIds]);

  const onSubmitProductDepotInfo = (
    productDepotInfoInput: IFarmInputProductDepotInfoInput[],
  ) => {
    setIsLoading(true);
    apiSaveProductDepotInfo(productDepotInfoInput)
      .then(async () => {
        const productIds = [props.product.id.toString()];
        const depotIds = Array.from(
          new Set(productDepotInfoInput.map((input) => input.depotId)),
        );
        const updates = await apiGetProductDepotInfo({productIds, depotIds});
        reduxUpdateProductDepotInfo(updates);
      })
      .then(() => setHasSuccessfullyUpdated(true))
      .catch((err) => {
        alert(
          'Failed to update inventory at the moment. Please try again later',
        );
        console.error(err);
      })
      .finally(() => setIsLoading(false));
  };

  const permissions = new PermissionsService(props.user);
  const canWriteDepotProduct = permissions.hasPermission(
    ESupplierUserPermissions.DEPOT_PRODUCT_WRITE,
  );

  if (hasSuccessfullyUpdated) {
    return (
      <Route
        render={() => (
          <div className="side-panel-success-container">
            <div className="mid-section">
              <div className="success-gif">
                <CheckIcon />
              </div>
              <div className="success-msg">Inventory updated successfully</div>
            </div>
            <div className="btn-container">
              <Button
                className="primary-btn"
                type="submit"
                variant="outlined"
                color="primary"
                disabled={isLoading}
                onClick={() => reduxToggleSidePanel(false, null)}
              >
                View Inventory
              </Button>
            </div>
          </div>
        )}
      />
    );
  }

  const LoadingForm = () => (
    <div className="form">
      <Skeleton variant={'rect'} height={600} />
    </div>
  );

  if (isLoadingDepotInfo) return <LoadingForm />;

  return (
    <InventoryForm
      user={props.user}
      productId={props.product!.id.toString()}
      depotIds={props.depotIds}
      allDepots={props.allDepots}
      productsDepotInfo={productDepotInfo}
      isLoading={isLoading}
      submitButtonTitle={'Update'}
      onSubmit={onSubmitProductDepotInfo}
      cancelButtonTitle={'Cancel'}
      onCancel={() => reduxToggleSidePanel(false)}
      readonly={!canWriteDepotProduct}
    />
  );
};
export default AddOrUpdateInventory;
